export default "__VITE_PUBLIC_ASSET__81858cec__"